import type { GridApi } from '@mui/x-data-grid-pro';
import { type RefObject, useCallback, useEffect } from 'react';
import { expandAncestorsForTargets } from '../jump-to-item/expandAncestors';

export const useAutoExpandSearchMatches = ({
  apiRef,
  matchedIds,
}: {
  apiRef: RefObject<GridApi>;
  matchedIds: number[];
}): void => {
  const expandMatchedAncestors = useCallback(() => {
    if (matchedIds.length === 0) return;
    expandAncestorsForTargets(apiRef, matchedIds);
  }, [apiRef, matchedIds]);

  useEffect(() => {
    const api = apiRef.current;
    if (!api) return;
    expandMatchedAncestors();
    return api.subscribeEvent('rowsSet', expandMatchedAncestors);
  }, [apiRef, expandMatchedAncestors]);
};
